import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import ReplaceableComponents from '~/components/higher-order/ReplaceableComponents';

const Container = styled.ul`
  list-style: none;
  padding: 0;
  margin-bottom: 0;
`;

export const components = {
  Container,
};

@ReplaceableComponents(components)
export default class DropdownMenuItemGroup extends React.Component {
  render() {
    const { children, ...props } = this.props;
    const { Container } = this.props.components;

    return <Container {...props}>{children}</Container>;
  }
}

DropdownMenuItemGroup.propTypes = {
  className: PropTypes.string,
};
